export class HospitalBed {
    id = null;
    name = null;
    code = null;
    description = null;
    isDuplicate = null;
    dupName = null;
    dupCode = null;
    isUsing = true
}